import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ClientMigrations } from "slot-definitions"
import { ClientDataMigrationDialog } from "../../client-data-migration-dialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getLegacyCustomSkills } from "./controller/get-legacy-custom-skills"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { importLegacyCustomSkills } from "./controller/import-legacy-custom-skills"

const CUSTOM_DATA_MIGRATION_SKILLS = "custom skills"

ClientMigrations.plug(<LegacyCustomSkills priority={200} />)

function LegacyCustomSkills() {
    const { subscriptionId } = useBoundContext()
    const dialog = useDialog(
        <ClientDataMigrationDialog
            type={CUSTOM_DATA_MIGRATION_SKILLS}
            subscriptionId={subscriptionId}
            query={getLegacyCustomSkills}
            getKey={(d) => d.customSkillingId}
        />
    )

    return (
        <Button
            variant="outlined"
            size="large"
            onClick={handleMigrate}
            startIcon={<Iconify icon={"ant-design:tool-filled"} />}
        >
            Custom Skills
        </Button>
    )

    async function handleMigrate() {
        const data = await dialog()
        if (data && data.length > 0) {
            try {
                const selectedIds = data.map("customSkillingId")
                await importLegacyCustomSkills(subscriptionId, selectedIds)
                successSnackbar("Custom skills successfully migrated")
            } catch (error) {
                errorSnackbar("Error migrating custom skills")
            }
        }
    }
}
